import { useEffect, useState } from "react";
import {
  Typography,
  Box,
  TextField,
  Button,
  Avatar,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { UseExpressDelivery } from "./UseExpressDelivery";
import { toMoney } from "../../util/Utils";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import CloseIcon from "@mui/icons-material/Close";

export default function LogesticDetails(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { cancelAlopeykOrder, updateAlopeykOrder, getExpressById } =
    UseExpressDelivery();
  const { isSmall } = useBreakpoints();
  const [details, setDetails] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
    type: undefined,
  });

  useEffect(() => {
    if (props.detailRes) {
      setDetails(props.detailRes.find((m) => m.id == props.openDialog.id));
    }
  }, [props.detailRes]);

  return (
    details && (
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography variant="subtitle1" color="secondary">
            جزئیات لجستیک
          </Typography>

          <Avatar sx={{ width: 56, height: 56 }} src={details.driverAvatar} />
        </Box>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn="span 12">
            <TextField
              fullWidth
              id="outlined-basic"
              label="آدرس"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              multiline
              maxRows={4}
              value={details.address ? details.address : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="لجستیک"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.logesticName ? details.logesticName : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label=" ثبت سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.shamsiLogdate ? details.shamsiLogdate : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="وضعیت"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.status ? details.status : ""}
              variant="filled"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 3"></Box>}
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مسافت"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.distance ? details.distance : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مدت زمان"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.duration ? details.duration : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="هزینه ارسال"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.deliveryCost ? toMoney(details.deliveryCost) : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="نوع پرداخت"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.payType ? details.payType : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تخمین رسیدن(مبدا/مقصد)"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                details.reciveEstimateTime ? details.reciveEstimateTime : ""
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label=" قبول سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.shamsiAccepted ? details.shamsiAccepted : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="ارسال سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.shamsiPicking ? details.shamsiPicking : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label=" اتمام سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.shamsiFinished ? details.shamsiFinished : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="بازگشت"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.hasreturn ? "دارد" : "ندارد"}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="پرداخت در مقصد"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.payatdest ? "دارد" : "ندارد"}
              variant="filled"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="نام راکب"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details ? details.driverFullname : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="شماره تماس راکب"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={details.driverPhone ? details.driverPhone : ""}
              variant="filled"
            />
          </Box>

          {/* {!isSmall && <Box gridColumn="span 6"></Box>} */}

          <Box sx={{ my: "auto" }} gridColumn={isSmall ? "span 6" : "span 3"}>
            <Button
              disabled={details.logesticID === 1}
              sx={{ width: "100px", mr: 2 }}
              variant="contained"
              onClick={() => window.open(details.trackingURL, "_blank")}
            >
              <MapOutlinedIcon sx={{ mr: 0.5 }} fontSize="small" />
              رهگیری
            </Button>
            <Button
              disabled={details.logesticID === 1}
              sx={{ width: "100px" }}
              variant="contained"
              onClick={
                (event) => setAnchorEl(event.currentTarget)

                // window.open(details.screenshotURL, "_blank")
              }
            >
              <ImageOutlinedIcon sx={{ mr: 0.5 }} fontSize="small" />
              نمای کلی
            </Button>
            <Dialog
              open={open}
              BackdropProps={{
                style: {
                  backdropFilter: "blur(3px)",
                  backgroundColor: "rgba(0,0,30,0.4)",
                },
              }}
              fullWidth
              maxWidth="md"
              onClose={() => setAnchorEl(null)}
            >
              <DialogContent
                sx={{
                  zIndex: 20000,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography sx={{ color: "secondary.main" }}>
                    نمای کلی
                  </Typography>
                  <IconButton onClick={() => setAnchorEl(null)}>
                    <CloseIcon sx={{ color: "secondary.main" }} />
                  </IconButton>
                </Box>
                <CardMedia
                  component="img"
                  // height="auto"
                  width="1000"
                  image={details.screenshotURL}
                />
              </DialogContent>
            </Dialog>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            mt: 4,
          }}
        >
          {details.logesticID !== 1 && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setProgress(true);
                let state = { id: details.id };
                updateAlopeykOrder(state, () => {
                  props.callback();
                });
              }}
            >
              بروزرسانی
            </Button>
          )}
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setCheckState({
                show: true,
                name: "لغو سفارش",
                type: "cancel",
              });
            }}
          >
            لغو ارسال
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              props.setOpenDialog({ show: false, model: "" });
            }}
          >
            بستن
          </Button>
        </Box>
        <YesOrNoDialoge
          checkState={checkState}
          setCheckState={setCheckState}
          callback={() => {
            let cancelState = {
              id: details.id,
            };
            setProgress(true);
            cancelAlopeykOrder(cancelState, () => {
              props.setOpenDialog({ show: false, model: "" });

              props.callback();
            });
          }}
        />
      </Box>
    )
  );
}
